<template>
  <div class="buildWayBillNo">
    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      :ellipsis="false"
      swipeable
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title"
        :name="menu.name"
        :disabled="menu.disable"
      >
        <van-form
          ref="formRef"
          label-width="120px"
          :show-error="false"
          :scroll-to-error="false"
          @failed="onFailed"
          @submit="handleSubmit"
        >
          <van-field
            v-model="userSelect.OperationUserIdStr"
            :label="$t.buildWayBillNo.operation"
            @click="pickerShow('showUserSelectPicker', 1)"
            :placeholder="$t.meta.select"
            clickable
            readonly
          />

          <van-field
            v-model="userSelect.SalesUserIdStr"
            :label="$t.buildWayBillNo.sales"
            @click="pickerShow('showUserSelectPicker', 2)"
            :placeholder="$t.meta.select"
            clickable
            readonly
          />

          <van-field
            v-model="userSelect.CustomerServiceUserIdStr"
            :label="$t.buildWayBillNo.kefu"
            @click="pickerShow('showUserSelectPicker', 3)"
            :placeholder="$t.meta.select"
            clickable
            readonly
          />

          <van-field
            v-model="userSelect.MarketUserIdStr"
            :label="$t.buildWayBillNo.marketing"
            @click="pickerShow('showUserSelectPicker', 4)"
            :placeholder="$t.meta.select"
            clickable
            readonly
          />

          <!-- 空运 -->
          <div v-if="menuState == 1">
            <van-field
              v-model="airform.WB_Number"
              label="Custom generate waybill number"
              name="Custom generate waybill number"
              :placeholder="$t.meta.input"
              type="textarea"
              rows="3"
              required
              :rules="formRule"
            />

            <van-field
              v-model="airform.DeliveryObj.text"
              label="Shipper Company"
              name="Shipper Company"
              :placeholder="$t.meta.input"
              @click="onShowEmit('showAirDeliveryObj')"
              clickable
              readonly
              required
              :rules="formRule"
            />

            <van-field
              v-model="airform.DeliveryContactIdStr"
              label="Contact person"
              @click="onShowEmit('showAirDeliveryPerson')"
              :placeholder="$t.meta.select"
              clickable
              readonly
            />

            <van-field v-model="airform.DeliveryMobile" label="Mob No." readonly />

            <van-field
              v-model="airform.SendCountry.text"
              label="Country/Airport of departure"
              @click="onShowEmit('showAirSendCountry')"
              :placeholder="$t.meta.select"
              clickable
              readonly
            />

            <van-field
              v-model="airform.DeliveryAddress"
              label="Address"
              :placeholder="$t.meta.input"
              type="textarea"
              rows="3"
            >
              <template #button>
                <van-button
                  size="small"
                  type="info"
                  native-type="button"
                  @click="onShowEmit('showAirDeliveryAddress')"
                  >{{ $t.meta.search }}</van-button
                >
              </template>
            </van-field>

            <van-field
              v-model="airform.ReceiveObj.text"
              label="Consignee Company"
              name="Consignee Company"
              :placeholder="$t.meta.input"
              @click="onShowEmit('showAirReceiveObj')"
              clickable
              readonly
              required
              :rules="formRule"
            />

            <van-field
              v-model="airform.ReceiveContactIdStr"
              label="Contact person"
              @click="onShowEmit('showAirReceivePerson')"
              :placeholder="$t.meta.select"
              clickable
              readonly
            />

            <van-field v-model="airform.ReceiveMoblie" label="Mob No." readonly />

            <van-field
              v-model="airform.ReceiveCountry.text"
              label="Country/Airport of destination"
              @click="onShowEmit('showAirReceiveCountry')"
              :placeholder="$t.meta.select"
              clickable
              readonly
            />

            <van-field
              v-model="airform.ReceiveAddress"
              label="Address"
              :placeholder="$t.meta.input"
              type="textarea"
              rows="3"
            >
              <template #button>
                <van-button
                  size="small"
                  type="info"
                  native-type="button"
                  @click="onShowEmit('showAirReceiveAddress')"
                  >{{ $t.meta.search }}</van-button
                >
              </template>
            </van-field>

            <van-field
              v-model="airform.AirlineTrackingNumber"
              label="Airline Tracking Number"
              name="Airline Tracking Number"
              :placeholder="$t.meta.input"
              type="textarea"
              rows="3"
              required
              :rules="formRule"
            />

            <van-field
              v-model="airform.AirlineCode"
              label="By First Carrier"
              name="By First Carrier"
              :placeholder="$t.meta.input"
              type="textarea"
              rows="3"
              required
              :rules="formRule"
            />

            <div class="custom-date">
              <div class="date-btn1">
                <div class="date-require">*</div>
                Flight/Date
              </div>
              <div class="date-btn2" @click="showTimeDate('DepartureDate')">
                <span v-if="airform.DepartureDate" class="value">{{
                  airform.DepartureDate
                }}</span>
                <span v-else class="placeholder">{{ $t.meta.select }}</span>
              </div>
            </div>

            <div class="buildWayBillNo-radio">
              <div class="radio-label">WT/VAL</div>
              <van-radio-group v-model="airform.WtAndVal" direction="horizontal">
                <van-radio name="1">PP</van-radio>
                <van-radio name="2">CC</van-radio>
              </van-radio-group>
            </div>

            <div class="buildWayBillNo-radio">
              <div class="radio-label">OTHER</div>
              <van-radio-group v-model="airform.Other" direction="horizontal">
                <van-radio name="1">PP</van-radio>
                <van-radio name="2">CC</van-radio>
              </van-radio-group>
            </div>

            <van-field
              v-model="airform.ChargeWeight"
              label="Chargeable Weight"
              name="Chargeable Weight"
              :placeholder="$t.meta.input"
              required
              :rules="formRule"
            />

            <van-field
              v-model="airform.PrepaidAmount"
              label="Prepaid"
              name="Prepaid"
              :placeholder="$t.meta.input"
              required
              :rules="formRule"
            />

            <van-field
              v-model="airform.CollectAmount"
              label="Collect"
              name="Collect"
              :placeholder="$t.meta.input"
              required
              :rules="formRule"
            />

            <van-field
              v-model="airform.Surcharge"
              label="Valuation Charge"
              name="Valuation Charge"
              :placeholder="$t.meta.input"
              required
              :rules="formRule"
            />

            <van-field
              v-model="airform.TotalAmount"
              label="Total Amount"
              name="Total Amount"
              :placeholder="$t.meta.input"
              required
              :rules="formRule"
            />

            <van-field
              v-model="airform.Remark"
              label="Remarks"
              :placeholder="$t.meta.input"
              type="textarea"
              rows="3"
            />

            <div class="multi-table" v-if="airform.DetailList">
              <van-field name="stepper" label="Shipment details" required>
                <template #input>
                  <van-stepper
                    :min="0"
                    :value="airform.DetailList.length"
                    @minus="handleAirDel"
                    @plus="handleAirAdd"
                    :disable-input="true"
                  />
                </template>
              </van-field>
              <div v-for="(item, index) in airform.DetailList" :key="index">
                <div class="multi-table-header">
                  <div class="multi-table-title"></div>
                  <div class="multi-table-btn" @click="handleAirDelByIndex(index)">
                    <van-icon name="close" />
                  </div>
                </div>

                <van-field
                  v-model="item.GoodsDescribe"
                  label="Commodities"
                  name="Commodities"
                  label-class="number-label"
                  :placeholder="$t.meta.input"
                  required
                  :rules="formRule"
                >
                  <template #button>
                    <van-button
                      size="small"
                      type="info"
                      native-type="button"
                      @click="onShowEmit('showCustomsCode', index)"
                      >{{ $t.buildWayBillNo.searchCustomsCode }}</van-button
                    >
                  </template>
                </van-field>

                <van-field
                  v-model="item.CustomsCode"
                  label="HS Code"
                  label-class="number-label"
                  :placeholder="$t.meta.input"
                >
                  <template #button>
                    <van-button
                      size="small"
                      type="info"
                      native-type="button"
                      @click="actionSelection(index)"
                      >{{ $t.buildWayBillNo.searchCommodityCode }}</van-button
                    >
                  </template>
                </van-field>

                <van-field
                  v-model="item.PackingSize"
                  label="Size"
                  name="Size"
                  :placeholder="$t.meta.input"
                  required
                  :rules="formRule"
                />
                <van-field
                  v-model="item.Weight"
                  label="Weight ( KG )"
                  @change="getAllWeight"
                  :placeholder="$t.meta.input"
                />
                <van-field
                  v-model="item.BoxNumber"
                  label="No. of Pieces"
                  name="No. of Pieces"
                  @change="getAllBoxNumber"
                  :placeholder="$t.meta.input"
                  required
                  :rules="formRule"
                />
                <van-field
                  v-model="item.Volume"
                  label="Volume/m³"
                  @change="getAllVolume"
                  :placeholder="$t.meta.input"
                />
                <van-field
                  v-model="item.ItemPrice"
                  label="Price"
                  name="Price"
                  :placeholder="$t.meta.input"
                  required
                  :rules="formRule"
                />
                <van-field
                  v-model="item.Currency"
                  label="Currency"
                  name="Currency"
                  :placeholder="$t.meta.input"
                  required
                  :rules="formRule"
                />
              </div>
            </div>

            <div class="title">Total</div>

            <van-field v-model="airform.AllWeight" label="Total of Weight/Kg" readonly />

            <van-field v-model="airform.AllBoxNumber" label="Total of Pieces" readonly />

            <van-field v-model="airform.AllVolume" label="Total of Volume/m³" readonly />
          </div>
          <!-- 海运 -->
          <div v-if="menuState == 2">
            <van-field
              v-model="seaform.WB_Number"
              label="Custom generate waybill number"
              name="Custom generate waybill number"
              :placeholder="$t.meta.input"
              type="textarea"
              rows="3"
              required
              :rules="formRule"
            />

            <van-field
              v-model="seaform.DeliveryObj.text"
              label="Shipper Company"
              name="Shipper Company"
              :placeholder="$t.meta.input"
              @click="onShowEmit('showSeaDeliveryObj')"
              clickable
              readonly
              required
              :rules="formRule"
            />
            <div v-if="!seaform.IsCO">
              <van-field
                v-model="seaform.DeliveryAddress"
                label="Address"
                name="Address"
                :placeholder="$t.meta.input"
                required
                :rules="formRule"
                type="textarea"
                rows="3"
              >
                <template #button>
                  <van-button
                    size="small"
                    type="info"
                    native-type="button"
                    @click="onShowEmit('showSeaDeliveryAddress')"
                    >{{ $t.meta.search }}</van-button
                  >
                </template>
              </van-field>
            </div>
            <van-field label="C/O" readonly>
              <template #right-icon>
                <van-switch
                  v-model="seaform.IsCO"
                  :active-value="true"
                  :inactive-value="false"
                  size="24"
                />
              </template>
            </van-field>
            <div v-if="seaform.IsCO">
              <van-field
                v-model="seaform.DeliveryObj2.text"
                label="Shipper Company"
                :placeholder="$t.meta.input"
                @click="onShowEmit('showSeaDeliveryObj2')"
                clickable
                readonly
              />
              <van-field
                v-model="seaform.Delivery2Address"
                label="Address"
                type="textarea"
                rows="3"
                readonly
              />
            </div>

            <van-field
              v-model="seaform.ReceiveObj.text"
              label="Consignee Company"
              name="Consignee Company"
              :placeholder="$t.meta.input"
              @click="onShowEmit('showSeaReceiveObj')"
              clickable
              readonly
              required
              :rules="formRule"
            />

            <van-field
              v-model="seaform.ReceiveContactIdStr"
              label="Contact person"
              @click="onShowEmit('showSeaDeliveryPerson')"
              :placeholder="$t.meta.select"
              clickable
              readonly
            />

            <van-field v-model="seaform.ReceiveMobile" label="Mob No." readonly />

            <van-field
              v-model="seaform.PostalCode"
              label="Postal code"
              :placeholder="$t.meta.input"
            />

            <van-field
              v-model="seaform.ReceiveAddress"
              label="Address"
              name="Address"
              :placeholder="$t.meta.input"
              type="textarea"
              rows="3"
              required
              :rules="formRule"
            >
              <template #button>
                <van-button
                  size="small"
                  type="info"
                  native-type="button"
                  @click="onShowEmit('showSeaReceiveAddress')"
                  >{{ $t.meta.search }}</van-button
                >
              </template>
            </van-field>

            <div class="title">Notify Party Insert Name , Address and Phone</div>

            <van-field label="Select another one" readonly>
              <template #right-icon>
                <van-switch
                  v-model="seaform.IsSelectAnotherOne"
                  :active-value="true"
                  :inactive-value="false"
                  size="24"
                />
              </template>
            </van-field>

            <div v-if="seaform.IsSelectAnotherOne">
              <van-field
                v-model="seaform.NotifyObj.text"
                label="Consignee Company"
                :placeholder="$t.meta.input"
                @click="onShowEmit('showSeaNotifyObj')"
                clickable
                readonly
                required
              />
              <van-field
                v-model="seaform.NotifyContactIdStr"
                label="Contact person"
                @click="onShowEmit('showSeaNotifyPerson')"
                :placeholder="$t.meta.select"
                clickable
                readonly
              />

              <van-field v-model="seaform.NotifyMobile" label="Mob No." readonly />

              <van-field
                v-model="seaform.NotifyPostalCode"
                label="Postal code"
                :placeholder="$t.meta.input"
              />

              <van-field
                v-model="seaform.NotifyAddress"
                label="Address"
                :placeholder="$t.meta.input"
                type="textarea"
                rows="3"
              >
                <template #button>
                  <van-button
                    size="small"
                    type="info"
                    native-type="button"
                    @click="onShowEmit('showSeaNotifyAddress')"
                    >{{ $t.meta.search }}</van-button
                  >
                </template>
              </van-field>
            </div>

            <div class="title">Forwarding Agent and References</div>

            <van-field
              v-model="seaform.AgentObj.text"
              label="Consignee Company"
              :placeholder="$t.meta.input"
              @click="onShowEmit('showSeaAgentObj')"
              clickable
              readonly
            />
            <van-field
              v-model="seaform.AgentContactIdStr"
              label="Contact person"
              @click="onShowEmit('showSeaAgentPerson')"
              :placeholder="$t.meta.select"
              clickable
              readonly
            />

            <van-field v-model="seaform.AgentMobile" label="Mob No." readonly />

            <van-field
              v-model="seaform.AgentPostalCode"
              label="Postal code"
              :placeholder="$t.meta.input"
            />

            <van-field
              v-model="seaform.AgentAddress"
              label="Address"
              :placeholder="$t.meta.input"
              type="textarea"
              rows="3"
              ><template #button>
                <van-button
                  size="small"
                  type="info"
                  native-type="button"
                  @click="onShowEmit('showSeaAgentAddress')"
                  >{{ $t.meta.search }}</van-button
                >
              </template>
            </van-field>

            <div class="title">Also Notify Party-Roulting & Instructions</div>

            <div class="buildWayBillNo-radio">
              <div class="radio-label">Currency</div>
              <van-radio-group v-model="seaform.Currency" direction="horizontal">
                <van-radio
                  v-for="(item, index) in currencyList"
                  :key="index"
                  :name="item.value"
                  >{{ item.text }}</van-radio
                >
              </van-radio-group>
            </div>

            <div class="buildWayBillNo-radio">
              <div class="radio-label">WT/VAL</div>
              <van-radio-group v-model="seaform.WtAndVal" direction="horizontal">
                <van-radio name="1">PP</van-radio>
                <van-radio name="2">CC</van-radio>
              </van-radio-group>
            </div>

            <div class="buildWayBillNo-radio">
              <div class="radio-label">OTHER</div>
              <van-radio-group v-model="seaform.Other" direction="horizontal">
                <van-radio name="1">PP</van-radio>
                <van-radio name="2">CC</van-radio>
              </van-radio-group>
            </div>

            <van-field
              v-model="seaform.BargeVoyage"
              label="Transport Pre-carriage by"
              :placeholder="$t.meta.input"
            />

            <van-field
              v-model="seaform.BargeVoyageCountry.text"
              label="Place of Receipt"
              @click="onShowEmit('showSeaBargeVoyageCountry')"
              :placeholder="$t.meta.select"
              clickable
              readonly
              type="textarea"
              rows="2"
            />

            <van-field
              v-model="seaform.VesselVoyage"
              label="Ocean Vessel Voy No."
              name="Ocean Vessel Voy No."
              :placeholder="$t.meta.input"
              required
              :rules="formRule"
            />

            <van-field
              v-model="seaform.SendCountry.text"
              label="Port of Loading"
              name="Port of Loading"
              @click="onShowEmit('showSeaSendCountry')"
              :placeholder="$t.meta.select"
              clickable
              readonly
              required
              :rules="formRule"
              type="textarea"
              rows="2"
            />

            <van-field
              v-model="seaform.UnLoad.text"
              label="Port of Discharges"
              name="Port of Discharges"
              @click="onShowEmit('showSeaUnLoad')"
              :placeholder="$t.meta.select"
              clickable
              readonly
              required
              :rules="formRule"
              type="textarea"
              rows="2"
            />

            <van-field
              v-model="seaform.ReceiveCountry.text"
              label="Place of Delivery"
              name="Place of Delivery"
              @click="onShowEmit('showSeaReceiveCountry')"
              :placeholder="$t.meta.select"
              clickable
              readonly
              required
              :rules="formRule"
              type="textarea"
              rows="2"
            />

            <van-field
              v-model="seaform.HandlingInfo"
              label="Handling Information"
              :placeholder="$t.meta.input"
              type="textarea"
              rows="3"
            />

            <van-field
              v-model="seaform.Marks"
              label="Shipping mark"
              :placeholder="$t.meta.input"
              type="textarea"
              rows="3"
            />

            <van-field
              v-model="seaform.Remark"
              label="Description of Goods"
              placeholder="If Dangerous Goods , see clause 20"
              type="textarea"
              rows="3"
            />

            <div class="title">Shipment details</div>

            <div class="custom-date">
              <div class="date-btn1">
                <div class="date-require">*</div>
                Ship on board date
              </div>
              <div class="date-btn2" @click="showTimeDate('SailingDate')">
                <span v-if="seaform.SailingDate" class="value">{{
                  seaform.SailingDate
                }}</span>
                <span v-else class="placeholder">{{ $t.meta.select }}</span>
              </div>
            </div>

            <div class="buildWayBillNo-radio">
              <div class="radio-label">Packing type</div>
              <van-radio-group
                v-model="seaform.PackingType"
                @change="packingTypeChange"
                direction="horizontal"
              >
                <van-radio name="1">FCL</van-radio>
                <van-radio name="2">LCL</van-radio>
              </van-radio-group>
            </div>

            <div class="custom-field">
              <div class="custom-field-label">Total No.of Containers</div>
              <div class="custom-field-value" v-if="seaform.PackingType == '1'">
                <div class="custom-field-number">
                  {{ seaform.TotalContainers_X20 }} x 20'
                </div>
                <div class="custom-field-number">
                  {{ seaform.TotalContainers_X40 }} x 40'
                </div>
                <div class="custom-field-number">
                  {{ seaform.TotalContainers_X40HQ }} x 40HQ
                </div>
                <div class="custom-field-number">
                  {{ seaform.TotalContainers_XOthers }} x Others
                </div>
              </div>
              <div class="custom-field-value" v-if="seaform.PackingType == '2'">
                <div class="custom-field-number">{{ seaform.AllVolume }} CBM</div>
              </div>
            </div>

            <div class="multi-table" v-if="seaform.DetailList">
              <van-field name="stepper" label="Containers detail" required>
                <template #input>
                  <van-stepper
                    :min="0"
                    :value="seaform.DetailList.length"
                    @minus="handleSeaDel"
                    @plus="handleSeaAdd"
                    :disable-input="true"
                  />
                </template>
              </van-field>
              <div v-for="(item, index) in seaform.DetailList" :key="index">
                <div class="multi-table-header">
                  <div class="multi-table-title"></div>
                  <div class="multi-table-btn" @click="handleSeaDelByIndex(index)">
                    <van-icon name="close" />
                  </div>
                </div>

                <van-field
                  v-model="item.GoodsDescribe"
                  label="Commodities"
                  name="Commodities"
                  label-class="number-label"
                  :placeholder="$t.meta.input"
                >
                  <template #button>
                    <van-button
                      size="small"
                      type="info"
                      native-type="button"
                      @click="onShowEmit('showCustomsCode', index)"
                      >{{ $t.buildWayBillNo.searchCustomsCode }}</van-button
                    >
                  </template>
                </van-field>

                <van-field
                  v-model="item.CustomsCode"
                  label="HS Code"
                  label-class="number-label"
                  :placeholder="$t.meta.input"
                  @change="getRemarkText(index)"
                >
                  <template #button>
                    <van-button
                      size="small"
                      type="info"
                      native-type="button"
                      @click="actionSelection(index)"
                      >{{ $t.buildWayBillNo.searchCommodityCode }}</van-button
                    >
                  </template>
                </van-field>

                <van-field
                  v-model="item.ContainerInfoStr"
                  label="Container Info"
                  @click="onShowEmit('showSeaContainer', index)"
                  :placeholder="$t.meta.select"
                  clickable
                  readonly
                />
                <van-field
                  v-model="item.CTIdStr"
                  label="Cabinet Type"
                  @click="cabinetPickerShow"
                  :placeholder="$t.meta.select"
                  clickable
                  readonly
                  v-if="seaform.PackingType == '1'"
                />
                <van-field
                  v-model="item.ContainerNo"
                  label="Container No."
                  :placeholder="$t.meta.input"
                />
                <van-field
                  v-model="item.SealNo"
                  label="Seal No."
                  :placeholder="$t.meta.input"
                />
                <van-field
                  v-model="item.Weight"
                  label="Weight ( KG )"
                  @change="getAllWeight"
                  :placeholder="$t.meta.input"
                />
                <van-field
                  v-model="item.Volume"
                  label="Volume/m³"
                  name="Volume/m³"
                  @change="getAllVolume"
                  :placeholder="$t.meta.input"
                  required
                  :rules="formRule"
                />
                <van-field
                  v-model="item.BoxNumber"
                  label="Total Carton"
                  name="Total Carton"
                  @change="getAllBoxNumber"
                  :placeholder="$t.meta.input"
                  required
                  :rules="formRule"
                />
                <van-field
                  v-model="item.Unit"
                  label="Unit"
                  :placeholder="$t.meta.input"
                />
              </div>
            </div>

            <div class="title">Total</div>

            <van-field v-model="seaform.AllWeight" label="Total of Weight/Kg" readonly />

            <van-field v-model="seaform.AllBoxNumber" label="Total of Pieces" readonly />

            <van-field v-model="seaform.AllVolume" label="Total of Volume/m³" readonly />

            <div class="title">
              Total Number of Containers and/or Packages ( in words )
            </div>

            <van-field
              name="Total Number of Containers and/or Packages"
              v-model="seaform.Cargo"
              :placeholder="$t.meta.input"
              required
              :rules="formRule"
              type="textarea"
              rows="5"
            />
          </div>
          <div v-if="menuState == 3 || menuState == 4 || menuState == 5">
            <div class="title">{{ $t.buildWayBillNo.shippingDetail }}</div>
            <van-field
              v-model="form.DeliveryObj.text"
              :label="$t.buildWayBillNo.shipperCompany"
              :name="$t.buildWayBillNo.shipperCompany"
              :placeholder="$t.meta.input"
              @click="onShowEmit('showFormDeliveryObj')"
              clickable
              readonly
              required
              :rules="formRule"
            />
            <template v-if="form.DeliveryObj.value">
              <van-field
                v-model="form.DeliveryObj.CustomerPhone"
                :label="$t.buildWayBillNo.phone"
                readonly
              />
              <van-field
                v-model="form.DeliveryObj.Address"
                :label="$t.buildWayBillNo.address"
                type="textarea"
                rows="3"
                readonly
              />
            </template>
            <van-field
              v-model="form.DeliveryCountry.text"
              :label="$t.buildWayBillNo.country"
              :name="$t.buildWayBillNo.country"
              type="textarea"
              rows="2"
              @click="onShowEmit('showFormDeliveryCountry')"
              :placeholder="$t.meta.select"
              clickable
              readonly
              required
              :rules="formRule"
            />
            <div class="title">{{ $t.buildWayBillNo.destination }}</div>
            <van-field
              v-model="form.ReceiveObj.text"
              :label="$t.buildWayBillNo.consigneeCompany"
              :name="$t.buildWayBillNo.consigneeCompany"
              :placeholder="$t.meta.input"
              @click="onShowEmit('showFormReceiveObj')"
              clickable
              readonly
              required
              :rules="formRule"
            />
            <template v-if="form.ReceiveObj.value">
              <van-field
                v-model="form.ReceiveObj.CustomerPhone"
                :label="$t.buildWayBillNo.phone"
                readonly
              />
              <van-field
                v-model="form.ReceiveObj.Address"
                :label="$t.buildWayBillNo.address"
                type="textarea"
                rows="3"
                readonly
              />
            </template>
            <van-field
              v-model="form.ReceiveCountry.text"
              :label="$t.buildWayBillNo.country"
              :name="$t.buildWayBillNo.country"
              type="textarea"
              rows="2"
              @click="onShowEmit('showFormReceiveCountry')"
              :placeholder="$t.meta.select"
              clickable
              readonly
              required
              :rules="formRule"
            />
            <van-field
              v-model="form.PostalCode"
              :label="$t.buildWayBillNo.postalCode"
              :placeholder="$t.meta.input"
            />
            <van-field
              v-model="form.POBOX"
              label="POBOX"
              name="POBOX"
              :placeholder="$t.meta.input"
              required
              :rules="formRule"
            />

            <div class="multi-table" v-if="form.DetailList">
              <van-field
                name="stepper"
                :label="$t.buildWayBillNo.trackNumberDetails"
                required
              >
                <template #input>
                  <van-stepper
                    :min="0"
                    :value="form.DetailList.length"
                    @minus="handleFormDel"
                    @plus="handleFormAdd"
                    :disable-input="true"
                  />
                </template>
              </van-field>
              <div v-for="(item, index) in form.DetailList" :key="index">
                <div class="multi-table-header">
                  <div class="multi-table-title"></div>
                  <div class="multi-table-btn" @click="handleFormDelByIndex(index)">
                    <van-icon name="close" />
                  </div>
                </div>

                <van-field
                  v-model="item.GoodsDescribe"
                  :label="$t.buildWayBillNo.productName"
                  :name="$t.buildWayBillNo.productName"
                  label-class="number-label"
                  :placeholder="$t.meta.input"
                  required
                  :rules="formRule"
                >
                  <template #button>
                    <van-button
                      size="small"
                      type="info"
                      native-type="button"
                      @click="onShowEmit('showCustomsCode', index)"
                      >{{ $t.buildWayBillNo.searchCustomsCode }}</van-button
                    >
                  </template>
                </van-field>

                <van-field
                  v-model="item.CustomsCode"
                  :label="$t.buildWayBillNo.customsCode"
                  label-class="number-label"
                  :placeholder="$t.meta.input"
                >
                  <template #button>
                    <van-button
                      size="small"
                      type="info"
                      native-type="button"
                      @click="actionSelection(index)"
                      >{{ $t.buildWayBillNo.searchCommodityCode }}</van-button
                    >
                  </template>
                </van-field>

                <van-field
                  v-model="item.COD"
                  label="COD amount"
                  name="COD amount"
                  :placeholder="$t.meta.input"
                  required
                  :rules="formRule"
                />
                <van-field
                  v-model="item.Weight"
                  :label="$t.buildWayBillNo.weight + '(KG)'"
                  :name="$t.buildWayBillNo.weight + '(KG)'"
                  @change="getAllWeight"
                  :placeholder="$t.meta.input"
                  required
                  :rules="formRule"
                />
                <van-field
                  v-model="item.BoxNumber"
                  :label="$t.buildWayBillNo.numberBoxes"
                  :name="$t.buildWayBillNo.numberBoxes"
                  @change="getAllBoxNumber"
                  :placeholder="$t.meta.input"
                  required
                  :rules="formRule"
                />
                <van-field
                  v-model="item.NumberUnit"
                  :label="$t.buildWayBillNo.boxUnit"
                  :name="$t.buildWayBillNo.boxUnit"
                  :placeholder="$t.meta.input"
                  required
                  :rules="formRule"
                />
                <van-field
                  v-model="item.Volume"
                  :label="$t.buildWayBillNo.volume + 'm³'"
                  :name="$t.buildWayBillNo.volume + 'm³'"
                  @change="getAllVolume"
                  :placeholder="$t.meta.input"
                  required
                  :rules="formRule"
                />
                <van-field
                  v-model="item.ItemPrice"
                  :label="$t.buildWayBillNo.value"
                  :placeholder="$t.meta.input"
                  required
                  :rules="formRule"
                />
                <van-field
                  v-model="item.Currency"
                  :label="$t.buildWayBillNo.currency"
                  :name="$t.buildWayBillNo.currency"
                  :placeholder="$t.meta.input"
                  required
                  :rules="formRule"
                />
                <van-field
                  v-model="item.CargoQuantity"
                  :label="$t.buildWayBillNo.cargoQuantity"
                  :name="$t.buildWayBillNo.cargoQuantity"
                  @change="getTotalCargoQuantity"
                  :placeholder="$t.meta.input"
                  required
                  :rules="formRule"
                />
              </div>
            </div>

            <div class="title">{{ $t.buildWayBillNo.others }}</div>
            <van-field
              v-model="form.TradingPlatform"
              :label="$t.buildWayBillNo.tradingPlatform"
              :placeholder="$t.meta.input"
            />

            <van-field
              v-model="form.Remark"
              :label="$t.buildWayBillNo.remark"
              :placeholder="$t.meta.input"
              type="textarea"
              rows="3"
            />

            <div class="title">{{ $t.buildWayBillNo.totalData }}</div>

            <van-field
              v-model="form.AllWeight"
              :label="$t.buildWayBillNo.totalWeight + 'KG'"
              readonly
            />

            <van-field
              v-model="form.AllBoxNumber"
              :label="$t.buildWayBillNo.totalCases"
              readonly
            />

            <van-field
              v-model="form.AllVolume"
              :label="$t.buildWayBillNo.volume + 'm³'"
              readonly
            />

            <van-field
              v-model="form.TotalCargoQuantity"
              :label="$t.buildWayBillNo.totalCargoQuantity"
              readonly
            />
          </div>

          <div class="tool-bar">
            <van-button
              type="info"
              class="submit-button"
              :style="{ width: menuState == 2 ? '70%' : '100%' }"
              block
              native-type="submit"
              >{{ $t.meta.submit }}</van-button
            >
            <van-button
              class="more-button"
              native-type="button"
              @click="handleMoreSheetShow"
              v-if="menuState == 2"
              >{{ $t.meta.more }}</van-button
            >
          </div>
        </van-form>
      </van-tab>
    </van-tabs>

    <!-- 空运 -->
    <fetch-list
      event="showAirDeliveryObj"
      type="customerManagement"
      request="getCustomerInfo"
      @onSelect="onSelectFetch"
    ></fetch-list>

    <address-fetch-list
      event="showAirDeliveryAddress"
      wbType="1"
      addressType="1"
      @onSelect="onSelectFetch"
    ></address-fetch-list>

    <option-list
      event="showAirDeliveryPerson"
      :options="contactPersonList.items1"
      @onSelect="onSelectOption"
    ></option-list>

    <address-fetch-list
      event="showAirReceiveAddress"
      wbType="1"
      addressType="2"
      @onSelect="onSelectFetch"
    ></address-fetch-list>

    <option-list
      event="showAirSendCountry"
      :options="countryList"
      @onSelect="onSelectOption"
    ></option-list>

    <fetch-list
      event="showAirReceiveObj"
      type="customerManagement"
      request="getCustomerInfo"
      @onSelect="onSelectFetch"
    ></fetch-list>

    <option-list
      event="showAirReceivePerson"
      :options="contactPersonList.items2"
      @onSelect="onSelectOption"
    ></option-list>

    <option-list
      event="showAirReceiveCountry"
      :options="countryList"
      @onSelect="onSelectOption"
    ></option-list>

    <!-- 海运 -->
    <fetch-list
      event="showSeaDeliveryObj"
      type="customerManagement"
      request="getCustomerInfo"
      @onSelect="onSelectFetch"
    ></fetch-list>

    <address-fetch-list
      event="showSeaDeliveryAddress"
      wbType="2"
      addressType="1"
      @onSelect="onSelectFetch"
    ></address-fetch-list>

    <fetch-list
      event="showSeaDeliveryObj2"
      type="customerManagement"
      request="getCustomerInfo"
      @onSelect="onSelectFetch"
    ></fetch-list>

    <fetch-list
      event="showSeaReceiveObj"
      type="customerManagement"
      request="getCustomerInfo"
      @onSelect="onSelectFetch"
    ></fetch-list>

    <address-fetch-list
      event="showSeaReceiveAddress"
      wbType="2"
      addressType="2"
      @onSelect="onSelectFetch"
    ></address-fetch-list>

    <option-list
      event="showSeaDeliveryPerson"
      :options="contactPersonList.items3"
      @onSelect="onSelectOption"
    ></option-list>

    <fetch-list
      event="showSeaNotifyObj"
      type="customerManagement"
      request="getCustomerInfo"
      @onSelect="onSelectFetch"
    ></fetch-list>

    <option-list
      event="showSeaNotifyPerson"
      :options="contactPersonList.items4"
      @onSelect="onSelectOption"
    ></option-list>

    <address-fetch-list
      event="showSeaNotifyAddress"
      wbType="2"
      addressType="3"
      @onSelect="onSelectFetch"
    ></address-fetch-list>

    <fetch-list
      event="showSeaAgentObj"
      type="customerManagement"
      request="getCustomerInfo"
      @onSelect="onSelectFetch"
    ></fetch-list>

    <option-list
      event="showSeaAgentPerson"
      :options="contactPersonList.items5"
      @onSelect="onSelectOption"
    ></option-list>

    <address-fetch-list
      event="showSeaAgentAddress"
      wbType="2"
      addressType="4"
      @onSelect="onSelectFetch"
    ></address-fetch-list>

    <option-list
      event="showSeaUnLoad"
      :options="countryList"
      @onSelect="onSelectOption"
    ></option-list>

    <option-list
      event="showSeaBargeVoyageCountry"
      :options="countryList"
      @onSelect="onSelectOption"
    ></option-list>

    <option-list
      event="showSeaSendCountry"
      :options="countryList"
      @onSelect="onSelectOption"
    ></option-list>

    <option-list
      event="showSeaReceiveCountry"
      :options="countryList"
      @onSelect="onSelectOption"
    ></option-list>

    <option-list
      event="showSeaContainer"
      :options="containerInfoSelectList"
      @onSelect="onSelectOption"
    ></option-list>

    <!-- 空派/海派/快递 -->
    <fetch-list
      event="showFormDeliveryObj"
      type="customerManagement"
      request="getCustomerInfo"
      @onSelect="onSelectFetch"
    ></fetch-list>

    <option-list
      event="showFormDeliveryCountry"
      :options="countryList"
      @onSelect="onSelectOption"
    ></option-list>

    <fetch-list
      event="showFormReceiveObj"
      type="customerManagement"
      request="getCustomerInfo"
      @onSelect="onSelectFetch"
    ></fetch-list>

    <option-list
      event="showFormReceiveCountry"
      :options="countryList"
      @onSelect="onSelectOption"
    ></option-list>

    <option-list
      event="showDialogBillingCountry"
      :options="dialogCountryList"
      @onSelect="countryConfirm"
    ></option-list>

    <option-list
      event="showDialogBillingService"
      :options="dialogFreightList"
      @onSelect="freightConfirm"
    ></option-list>

    <customsCode-fetch-list
      event="showCustomsCode"
      :searchText="form.DetailList[detailIndex].GoodsDescribe"
      @onSelect="onSelectFetch"
    ></customsCode-fetch-list>

    <van-action-sheet
      v-model="moreSheetShow"
      :actions="moreSheetActions"
      @select="moreSheetSelect"
    />

    <van-popup v-model="showUserSelectPicker" round position="bottom">
      <van-picker
        :title="$t.buildWayBillNo.selectUser"
        show-toolbar
        :columns="userList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="userSelectConfirm($event)"
        @cancel="showUserSelectPicker = false"
      />
    </van-popup>

    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.buildWayBillNo.selectDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event)"
        @cancel="showTimePicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup
      v-model="showCabinetPicker"
      round
      position="bottom"
      v-if="seaform.PackingType == 1"
    >
      <van-picker
        title="Cabinet Type"
        show-toolbar
        :columns="
          seaform.DetailList[this.detailIndex]
            ? seaform.DetailList[this.detailIndex].Options
            : []
        "
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="cabinetSelectConfirm($event)"
        @cancel="showCabinetPicker = false"
      />
    </van-popup>

    <van-dialog
      :title="$t.buildWayBillNo.wbNumberData"
      width="90%"
      v-model="dialogSeaVisible"
      @cancel="dialogSeaVisible = false"
      @confirm="dialogSeaConfirm"
      :cancel-button-text="$t.meta.close"
      :confirm-button-text="$t.meta.confirm"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="buildWayBillNo-alert">
          <van-form label-width="100px">
            <van-field
              v-model="dialogSeaForm.WB_Number"
              :label="$t.buildWayBillNo.wbNumber"
              :placeholder="$t.meta.input"
              required
            />
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="getDialogTitle()"
      width="90%"
      v-model="dialogBillingVisible"
      @cancel="dialogCancel"
      @confirm="dialogSubmit"
      :cancel-button-text="getDialogCancelText()"
      :confirm-button-text="getDialogConfirmText()"
      :show-cancel-button="true"
      :show-confirm-button="true"
      :before-close="
        (action, done) => {
          done(false);
        }
      "
    >
      <slot name="default">
        <div
          class="billing-alert"
          :style="{ height: dialogBillingStep == 1 ? 'auto' : '100vw' }"
        >
          <van-form label-width="100px" v-if="dialogBillingStep == 1">
            <van-field
              clickable
              readonly
              :value="dialogBillingForm.FPIdStr"
              :label="$t.onlineOrder.countryName"
              :placeholder="$t.meta.select"
              @click="onShowEmit('showDialogBillingCountry')"
            />

            <van-field
              clickable
              readonly
              :value="dialogBillingForm.FPDIdStr"
              :label="$t.onlineOrder.cargoCategorySn"
              :placeholder="$t.meta.select"
              @click="onShowEmit('showDialogBillingService')"
            />

            <van-field
              v-model="dialogBillingForm.Length"
              :label="$t.onlineOrder.length + ' ( cbm )'"
              :placeholder="$t.meta.input"
            />

            <van-field
              v-model="dialogBillingForm.Width"
              :label="$t.onlineOrder.width + ' ( cbm )'"
              :placeholder="$t.meta.input"
            />

            <van-field
              v-model="dialogBillingForm.Height"
              :label="$t.onlineOrder.height + ' ( cbm )'"
              :placeholder="$t.meta.input"
            />

            <van-field
              v-model="dialogBillingForm.WeightKG"
              :label="$t.onlineOrder.weight + ' ( KG )'"
              :placeholder="$t.meta.input"
            />
          </van-form>
          <div class="dialog-container" v-if="dialogBillingStep == 2">
            <div
              class="dialog-table"
              v-for="(item, index) in dialogBillingData"
              :key="index"
            >
              <van-collapse v-model="activeNames">
                <van-collapse-item :name="index">
                  <template #title>
                    <div class="dialog-item">
                      {{ $t.onlineOrder.cargoCategorySn }}：{{
                        item.CountryCargoCategory
                      }}
                    </div>
                    <div class="dialog-item">
                      {{ $t.onlineOrder.firstWeightSn }}：
                      <span
                        >{{ item.FirstWeight }} <span v-if="item.WeightUnit == 1">KG</span
                        ><span v-if="item.WeightUnit == 2">cbm</span></span
                      >
                    </div>
                    <div class="dialog-item">
                      {{ $t.onlineOrder.firstWeightPrice }}：{{ item.CurrencySymbol }}
                      {{ item.FirstWeightPrice }}
                    </div>
                    <div class="dialog-item">
                      {{ $t.onlineOrder.continueWeightSn }}：
                      <span
                        >{{ item.ContinuousWeight }}
                        <span v-if="item.WeightUnit == 1">KG</span
                        ><span v-if="item.WeightUnit == 2">cbm</span></span
                      >
                    </div>
                    <div class="dialog-item">
                      {{ $t.onlineOrder.continuePrice }}：{{ item.CurrencySymbol }}
                      {{ item.ContinuousWeightPrice }}
                    </div>
                    <div class="dialog-item">
                      {{ $t.onlineOrder.totalFreight }}：<span style="color: red"
                        >{{ item.CurrencySymbol }} {{ item.TotalFreight }}</span
                      >
                    </div>
                    <div class="dialog-item">
                      {{ $t.onlineOrder.taxTotal }}：{{ item.CurrencySymbol }}
                      {{ item.TotalTax }}
                    </div>
                  </template>

                  <van-row
                    class="dialog-item-row"
                    v-for="(text, idx) in item.FreightCalculationDetailedExplanationList"
                    :key="idx"
                  >
                    <van-col span="24">{{ text }}</van-col>
                  </van-row>
                </van-collapse-item>
              </van-collapse>
              <div class="dialog-table-footer" v-if="item.TotalTax">
                <van-button
                  class="primary-btn"
                  size="small"
                  type="primary"
                  @click="showCalculate(item.TaxResultList)"
                  >{{ $t.onlineOrder.taxStep }}</van-button
                >
              </div>
            </div>
          </div>
          <van-form label-width="100px" v-if="dialogBillingStep == 3">
            <van-field
              v-model="dialogBillingForm.declaredValue"
              :label="$t.onlineOrder.declareValue"
              readonly
            />

            <van-field
              v-model="dialogBillingForm.declaredValueCurrency"
              :label="$t.onlineOrder.declareValueCurrency"
              readonly
            />

            <van-field
              v-model="dialogBillingForm.deliveryZipCode"
              :label="$t.onlineOrder.deliveryZipCode"
              :placeholder="$t.meta.input"
              required
            />

            <!-- Naqel -->
            <div v-if="form.LogisticsChannel == 1">
              <div class="custom-date2">
                <div class="date-btn1">
                  <div class="date-require">*</div>
                  {{ $t.onlineOrder.naqel_ShippingDateTime }}
                </div>
                <div class="date-btn2" @click="showDialogTimeDate">
                  <span v-if="dialogBillingForm.Naqel_ShippingDateTime" class="value">{{
                    dialogBillingForm.Naqel_ShippingDateTime
                  }}</span>
                  <span v-else class="placeholder">{{ $t.meta.select }}</span>
                </div>
              </div>

              <van-field
                v-model="dialogBillingForm.Naqel_DescriptionOfGoods"
                :label="$t.onlineOrder.naqel_DescriptionOfGoods"
                :placeholder="$t.meta.input"
                required
              />

              <van-field
                v-model="dialogBillingForm.Naqel_NumberOfPieces"
                :label="$t.onlineOrder.naqel_NumberOfPieces"
                :placeholder="$t.meta.input"
                required
                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
              />
            </div>

            <!-- iMile -->
            <div v-if="form.LogisticsChannel == 2">
              <van-field
                v-model="dialogBillingForm.iMile_PackageTotalVolume"
                :label="$t.onlineOrder.iMile_PackageTotalVolume + ' ( cm3 )'"
                :placeholder="$t.meta.input"
                required
                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
              />

              <van-field
                v-model="dialogBillingForm.iMile_PackageGrossWeight"
                :label="$t.onlineOrder.iMile_PackageGrossWeight + ' ( kg )'"
                :placeholder="$t.meta.input"
                required
                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
              />

              <van-field
                v-model="dialogBillingForm.iMile_PackageTotalCount"
                :label="$t.onlineOrder.iMile_PackageTotalCount"
                :placeholder="$t.meta.input"
                required
                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
              />

              <van-field
                v-model="dialogBillingForm.iMile_PackageGoodsType"
                :label="$t.onlineOrder.iMile_PackageGoodsType"
                @click="showGoodsTypePicker = true"
                :placeholder="$t.meta.select"
                clickable
                readonly
                required
              />
            </div>
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-popup v-model="showDialogTimePicker" position="bottom">
      <van-datetime-picker
        type="datetime"
        :title="$t.onlineOrder.naqel_ShippingDateTime"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange2($event)"
        @cancel="showDialogTimePicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showGoodsTypePicker" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.iMile_PackageGoodsType"
        show-toolbar
        :columns="packageGoodsTypeList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="typeConfirm"
        @cancel="showGoodsTypePicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  DatetimePicker,
  Uploader,
  Stepper,
  Picker,
  Tab,
  Tabs,
  Switch,
  ActionSheet,
  Row,
  Col,
  Collapse,
  CollapseItem,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(DatetimePicker)
  .use(Uploader)
  .use(Stepper)
  .use(Picker)
  .use(Tab)
  .use(Tabs)
  .use(Switch)
  .use(ActionSheet)
  .use(Row)
  .use(Col)
  .use(Collapse)
  .use(CollapseItem);

import FetchList from "@components/fetchList/FetchList.vue";
import OptionList from "@components/optionList/OptionList.vue";
import AddressFetchList from "@components/addressFetchList/AddressFetchList.vue";
import CustomsCodeFetchList from "@components/customsCodeFetchList/CustomsCodeFetchList.vue";
import Selection from "./selection/index.js";

export default {
  name: "buildWayBillNo",
  components: {
    FetchList,
    OptionList,
    AddressFetchList,
    CustomsCodeFetchList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      language: localStorage.getItem("requestLanguage") || "auto",
      SOPId: "",
      COIds: [],
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [
        {
          title: this.$t.meta.wbType1,
          name: 1,
          disable: false,
        },
        {
          title: this.$t.meta.wbType2,
          name: 2,
          disable: false,
        },
        {
          title: this.$t.meta.wbType3,
          name: 3,
          disable: false,
        },
        {
          title: this.$t.meta.wbType4,
          name: 4,
          disable: false,
        },
        {
          title: this.$t.meta.wbType5,
          name: 5,
          disable: false,
        },
      ],
      userList: [],
      currencyList: [],
      countryList: [],
      contactPersonList: {
        items1: [],
        items2: [],
        items3: [],
        items4: [],
        items5: [],
      },
      containerInfoSelectList: [],
      detailIndex: 0,
      userSelect: {
        OperationUserIdStr: "",
        OperationUserId: "",
        SalesUserIdStr: "",
        SalesUserId: "",
        CustomerServiceUserIdStr: "",
        CustomerServiceUserId: "",
        MarketUserIdStr: "",
        MarketUserId: "",
      },
      airform: {
        WB_Number: "",
        DeliveryObj: { text: "", value: "", CustomerNumber: "" },
        DeliveryContactIdStr: "",
        DeliveryContactId: "",
        DeliveryMobile: "",
        SendCountry: { text: "", value: "", CountryId: "", Code: "" },
        DeliveryAddress: "",
        ReceiveObj: { text: "", value: "", CustomerNumber: "" },
        ReceiveContactIdStr: "",
        ReceiveContactId: "",
        ReceiveMoblie: "",
        ReceiveCountry: { text: "", value: "", CountryId: "", Code: "" },
        ReceiveAddress: "",
        AirlineTrackingNumber: "",
        AirlineCode: "",
        DepartureDate: "",
        WtAndVal: "1",
        Other: "1",
        ChargeWeight: "",
        PrepaidAmount: "",
        CollectAmount: "",
        Surcharge: "",
        TotalAmount: "",
        DetailList: [
          {
            GoodsDescribe: "",
            CustomsCode: "",
            COD: "",
            Weight: "",
            BoxNumber: "",
            Volume: "",
            ItemPrice: "",
            Currency: "",
            NumberUnit: "",
          },
        ],
        Remark: "",
        AllWeight: 0,
        AllBoxNumber: 0,
        AllVolume: 0,
      },
      seaform: {
        WB_Number: "",
        DeliveryObj: { text: "", value: "", CustomerNumber: "" },
        DeliveryAddress: "",
        IsCO: false,
        DeliveryObj2: { text: "", value: "", CustomerNumber: "" },
        Delivery2Address: "",
        ReceiveObj: { text: "", value: "", CustomerNumber: "" },
        ReceiveAddress: "",
        ReceiveContactIdStr: "",
        ReceiveContactId: "",
        ReceiveMobile: "",
        PostalCode: "",
        IsSelectAnotherOne: false,
        NotifyObj: { text: "", value: "", CustomerNumber: "" },
        NotifyAddress: "",
        NotifyContactIdStr: "",
        NotifyContactId: "",
        NotifyMobile: "",
        NotifyPostalCode: "",
        AgentObj: { text: "", value: "", CustomerNumber: "" },
        AgentAddress: "",
        AgentContactIdStr: "",
        AgentContactId: "",
        AgentMobile: "",
        AgentPostalCode: "",
        WtAndVal: "1",
        Other: "1",
        Currency: "",
        BargeVoyage: "",
        VesselVoyage: "",
        UnLoad: { text: "", value: "", CountryId: "", Code: "" },
        BargeVoyageCountry: { text: "", value: "", CountryId: "", Code: "" },
        SendCountry: { text: "", value: "", CountryId: "", Code: "" },
        ReceiveCountry: { text: "", value: "", CountryId: "", Code: "" },
        HandlingInfo: "",
        Marks: "",
        Remark: "",
        PackingType: "1",
        DetailList: [
          {
            GoodsDescribe: "",
            CustomsCode: "",
            ContainerInfoStr: "",
            ContainerInfo: "",
            CTIdStr: "",
            CTId: "",
            ContainerNo: "",
            Weight: "",
            BoxNumber: "",
            Volume: "",
            SealNo: "",
            Unit: "",
            Options: [],
          },
        ],
        Cargo: "",
        AllWeight: 0,
        AllBoxNumber: 0,
        AllVolume: 0,
        TotalContainers_X20: 0,
        TotalContainers_X40: 0,
        TotalContainers_X40HQ: 0,
        TotalContainers_XOthers: 0,
      },
      form: {
        DeliveryObj: {},
        DeliveryCountry: { text: "", value: "", CountryId: "", Code: "" },
        ReceiveObj: {},
        ReceiveCountry: { text: "", value: "", CountryId: "", Code: "" },
        PostalCode: "",
        POBOX: "",
        TradingPlatform: "",
        Remark: "",
        DetailList: [
          {
            GoodsDescribe: "",
            CustomsCode: "",
            COD: "",
            Weight: "",
            BoxNumber: "",
            Volume: "",
            ItemPrice: "",
            Currency: "",
            NumberUnit: "",
            CargoQuantity: "",
          },
        ],
        AllWeight: 0,
        AllBoxNumber: 0,
        AllVolume: 0,
        TotalCargoQuantity: 0,
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      //日期
      selectDate: new Date(),
      currentDate: "",
      dateTimeParam: "",
      showTimePicker: false,
      //picker
      userSelectPickerType: 1,
      showUserSelectPicker: false,
      showCabinetPicker: false,
      selectEvent: "",
      //更多
      moreSheetShow: false,
      moreSheetActions: [],
      //海运数据加载
      dialogSeaVisible: false,
      dialogSeaForm: {
        WB_Number: "",
      },
      //出境启运-输入计费信息
      dialogBillingData: [],
      dialogBillingVisible: false,
      dialogBillingStep: 1,
      dialogBillingForm: {
        FPId: "",
        FPIdStr: "",
        FPDId: "",
        FPDIdStr: "",
        Length: null,
        Width: null,
        Height: null,
        WeightKG: null,
        declaredValue: null,
        declaredValueCurrency: null,
        deliveryZipCode: "",
        //Naqel
        Naqel_ShippingDateTime: "",
        Naqel_DescriptionOfGoods: "",
        Naqel_NumberOfPieces: null,
        //iMile
        iMile_PackageTotalVolume: null,
        iMile_PackageGrossWeight: null,
        iMile_PackageTotalCount: null,
        iMile_PackageGoodsType: "",
      },
      dialogCountryList: [],
      dialogFreightList: [],
      activeNames: [],
      showDialogTimePicker: false,
      showGoodsTypePicker: false,
      showDialogBillingCountry: false,
      showDialogBillingService: false,
      packageGoodsTypeList: ["Normal", "Sensitive", "Battery", "PureBattery"],
    };
  },
  watch: {
    menuState() {
      this.getCountryList(true);
    },
  },
  mounted() {
    const { COIds, SOPId } = this.$route.query;
    if (COIds) {
      this.COIds = COIds;
      this.disableMenuList();
      this.getOptions().then((success) => {
        if (success) this.loadWaybillByCOIdList();
      });
    } else if (SOPId) {
      this.SOPId = SOPId;
      this.disableMenuList();
      this.getOptions();
    } else {
      this.getOptions();
    }
  },
  methods: {
    actionSelection(index) {
      const selection = Selection();
      selection.onSelected = (data) => {
        if (this.menuState == 1) {
          this.airform.DetailList[index].CustomsCode = data["hs code"];
        } else if (this.menuState == 2) {
          this.seaform.DetailList[index].CustomsCode = data["hs code"];
          this.getRemarkText(index);
        } else {
          this.form.DetailList[index].CustomsCode = data["hs code"];
        }
        this.$forceUpdate();
      };
      selection.show();
    },
    typeConfirm(val) {
      if (!val) {
        return;
      }
      this.dialogBillingForm.iMile_PackageGoodsType = val;
      this.showGoodsTypePicker = false;
    },
    getDialogConfirmText() {
      if (this.dialogBillingStep == 1) {
        return this.$t.onlineOrder.nextStep;
      }
      if (this.dialogBillingStep == 2) {
        if (this.form.LogisticsChannel) {
          return this.$t.onlineOrder.nextStep;
        } else {
          return this.$t.meta.confirm;
        }
      }
      if (this.dialogBillingStep == 3) {
        return this.$t.meta.confirm;
      }
    },
    getDialogCancelText() {
      if (this.dialogBillingStep == 1) {
        return this.$t.meta.close;
      }
      if (this.dialogBillingStep == 2) {
        return this.$t.onlineOrder.prevStep;
      }
      if (this.dialogBillingStep == 3) {
        return this.$t.onlineOrder.prevStep;
      }
    },
    getDialogTitle() {
      if (this.dialogBillingStep == 1) {
        return this.$t.onlineOrder.dialogBillingTitle1;
      }
      if (this.dialogBillingStep == 2) {
        return this.$t.onlineOrder.dialogBillingTitle2;
      }
      if (this.dialogBillingStep == 3) {
        return this.$t.onlineOrder.dialogBillingTitle3;
      }
    },
    dialogSubmit() {
      if (this.dialogBillingStep == 1) {
        if (!this.dialogBillingForm.FPDId) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.select + " " + this.$t.onlineOrder.cargoCategorySn,
          });
          return;
        }
        this.freightPriceCalculator().then((success) => {
          if (success) {
            this.dialogBillingStep = 2;
          }
        });
      } else if (this.dialogBillingStep == 2) {
        if (this.form.LogisticsChannel) {
          this.getDeclaredValue();
          this.getDeclaredValueCurrency();
          this.dialogBillingStep = 3;
        } else {
          this.onSubmit();
        }
      } else if (this.dialogBillingStep == 3) {
        this.onSubmit();
      }
    },
    dialogCancel() {
      if (this.dialogBillingStep == 1) {
        this.dialogBillingVisible = false;
      } else if (this.dialogBillingStep == 2) {
        this.dialogBillingStep = 1;
      } else if (this.dialogBillingStep == 3) {
        this.dialogBillingStep = 2;
      }
    },
    dialogBillingShow() {
      this.getDialogOptions().then((success) => {
        if (success) {
          var country = this.dialogCountryList.find(
            (c) => c.value == this.dialogBillingForm.FPId
          );
          if (country) {
            this.dialogBillingForm.FPIdStr = country.text;
          }
          var service = this.dialogFreightList.find(
            (c) => c.value == this.dialogBillingForm.FPDId
          );
          if (service) {
            this.dialogBillingForm.FPDIdStr = service.text;
          }
          this.dialogBillingVisible = true;
        }
      });
    },
    getDialogOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([this.getFreightPriceListByPage(), this.loadFreightPriceInfo()])
          .then((success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          })
          .catch(() => {
            this.$commonMethod.hideLoading();
          });
      });
    },
    getFreightPriceListByPage() {
      return new Promise((resolve) => {
        this.$api.onlineOrderManagement
          .getFreightPriceListByPage()
          .then((res) => {
            var result = [];
            res.data.Data.forEach((item) => {
              let data = {
                text: item.CountryName,
                value: item.FPId,
              };
              result.push(data);
            });
            this.dialogCountryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    loadFreightPriceInfo() {
      return new Promise((resolve) => {
        var param = {
          FPId: this.dialogBillingForm.FPId,
        };
        this.$api.onlineOrderManagement
          .loadFreightPriceInfo(param)
          .then((res) => {
            var result = [];
            res.data.DetailList.forEach((item) => {
              let data = {
                text: this.language == "zh" ? item.CargoCategory : item.CargoCategoryEn,
                value: item.FPDId,
              };
              result.push(data);
            });
            this.dialogFreightList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    countryConfirm(e) {
      this.dialogBillingForm.FPIdStr = e.text;
      this.dialogBillingForm.FPId = e.value;
      this.showDialogBillingCountry = false;
      this.dialogBillingForm.FPDIdStr = "";
      this.dialogBillingForm.FPDId = "";
      this.loadFreightPriceInfo();
      this.$forceUpdate();
    },
    freightConfirm(e) {
      this.dialogBillingForm.FPDIdStr = e.text;
      this.dialogBillingForm.FPDId = e.value;
      this.showDialogBillingService = false;
      this.$forceUpdate();
    },
    freightPriceCalculator() {
      return new Promise((resolve) => {
        var param = {
          FPId: this.dialogBillingForm.FPId,
          FPDId: this.dialogBillingForm.FPDId,
          Length: this.dialogBillingForm.Length,
          Width: this.dialogBillingForm.Width,
          Height: this.dialogBillingForm.Height,
          WeightKG: this.dialogBillingForm.WeightKG,
        };
        var detailList = [];
        for (var detail of this.form.DetailList) {
          detailList.push({
            COId: detail.COId,
            ItemPrice: detail.ItemPrice,
            Currency: detail.Currency,
          });
        }
        param.DetailList = detailList;
        this.$commonMethod.showLoading();
        this.$api.calculator
          .freightPriceCalculator(param)
          .then((res) => {
            this.dialogBillingData = res.data;
            if (
              this.dialogBillingData[0] &&
              this.dialogBillingData[0].IsTaxFeebearingPartyInconsistent
            ) {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
                msg: this.$t.onlineOrder.isTaxFeebearingPartyInconsistent,
              });
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    showCalculate(lists) {
      var messages = [];
      for (var list of lists) {
        if (list.CalculateStepsList) {
          for (var text of list.CalculateStepsList) {
            messages.push(text);
          }
        }
      }
      messages = messages.join("<br/><br/>");
      this.$commonMethod.customAlert2(
        {
          message: messages,
          showCancelButton: false,
          confirmButtonText: this.$t.alert.confirmButtonText,
        },
        () => {},
        () => {}
      );
    },
    getDeclaredValue() {
      let num = 0;
      this.form.DetailList.forEach((item) => (num = Number(item["ItemPrice"]) + num));
      this.dialogBillingForm["declaredValue"] = num.toFixed(3);
    },
    getDeclaredValueCurrency() {
      if (this.form.DetailList.length) {
        if (this.form.DetailList[0] && this.form.DetailList[0].Currency) {
          this.dialogBillingForm.declaredValueCurrency = this.form.DetailList[0].Currency.toUpperCase();
        } else {
          this.dialogBillingForm.declaredValueCurrency = "";
        }
      }
    },
    loadWaybillByCOIdList() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.logisticsManagement
          .loadWaybillByCOIdList({
            COIdList: this.COIds,
          })
          .then((res) => {
            var data = res.data;
            this.form.POBOX = data.POBOX;
            this.form.PostalCode = data.PostalCode;
            this.form.TradingPlatform = data.TradingPlatform;
            this.form.DetailList = data.DetailList;
            this.form.Remark = data.Remark;
            //发货人
            this.form.DeliveryObj.value = data.DeliveryCustomerId;
            this.form.DeliveryObj.text = data.DeliveryCompanyEn
              ? data.DeliveryCompanyEn
              : data.DeliveryCompany;
            this.form.DeliveryObj.Address = data.DeliveryAddress;
            this.form.DeliveryObj.CustomerPhone = data.DeliveryPhone;
            //发货国家
            this.form.DeliveryCountry.value = data.DeliveryCountryId;
            var deliveryCountry = this.countryList.find(
              (c) => c.value == data.DeliveryCityId
            );
            if (deliveryCountry) {
              this.form.DeliveryCountry.text = deliveryCountry.text;
              this.form.DeliveryCountry.Code = deliveryCountry.Code;
              this.form.DeliveryCountry.CountryId = deliveryCountry.CountryId;
            }
            //收货人
            this.form.ReceiveObj.value = data.ReceiveCustomerId;
            this.form.ReceiveObj.text = data.ReceiveCompanyEn
              ? data.ReceiveCompanyEn
              : data.ReceiveCompany;
            this.form.ReceiveObj.Address = data.ReceiveAddress;
            this.form.ReceiveObj.CustomerPhone = data.DeliveryPhone;
            //收货国家
            this.form.ReceiveCountry.value = data.ReceiveCountryId;
            var receiveCountry = this.countryList.find(
              (c) => c.value == data.ReceiveCityId
            );
            if (receiveCountry) {
              this.form.ReceiveCountry.text = receiveCountry.text;
              this.form.ReceiveCountry.Code = receiveCountry.Code;
              this.form.ReceiveCountry.CountryId = receiveCountry.CountryId;
            }
            //分销商
            this.form.LogisticsChannel = data.LogisticsChannel;
            //数据合计
            this.form.AllWeight = data.AllWeight;
            this.form.AllVolume = data.AllVolume;
            this.form.AllBoxNumber = data.AllBoxNumber;
            this.form.TotalCargoQuantity = data.TotalCargoQuantity;
            //计费信息
            this.dialogBillingForm.FPId = data.FPId;
            this.dialogBillingForm.FPDId = data.FPDId;
            resolve(true);
            this.$commonMethod.hideLoading();
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    dialogSeaConfirm() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.logisticsManagement
          .getWayBillDetail({
            WB_Number: this.dialogSeaForm.WB_Number,
          })
          .then((res) => {
            var data = res.data;
            this.seaform.PostalCode = data.PostalCode;
            this.seaform.NotifyPostalCode = data.NotifyPostalCode;
            this.seaform.AgentPostalCode = data.AgentPostalCode;
            this.seaform.IsCO = data.IsCO == 1 ? true : false;
            this.seaform.IsSelectAnotherOne = data.IsSelectAnotherOne == 1 ? true : false;
            //发货人
            this.seaform.DeliveryObj.value = data.DeliveryCustomerId;
            this.seaform.DeliveryObj.text = data.DeliveryCompanyEn
              ? data.DeliveryCompanyEn
              : data.DeliveryCompany;
            this.seaform.DeliveryAddress = data.DeliveryAddress;
            //第二发货人
            this.seaform.DeliveryObj2.value = data.SecondDeliveryCustomerId;
            this.seaform.DeliveryObj2.text = data.SecondDeliveryCompanyEn
              ? data.SecondDeliveryCompanyEn
              : data.SecondDeliveryCompany;
            this.seaform.Delivery2Address = data.SecondDeliveryAddress;
            //收货人
            this.seaform.ReceiveObj.value = data.ReceiveCustomerId;
            this.seaform.ReceiveObj.text = data.ReceiveCompanyEn
              ? data.ReceiveCompanyEn
              : data.ReceiveCompany;
            this.seaform.ReceiveAddress = data.ReceiveAddress;
            if (data.ReceiveCustomerId) {
              this.getCustomerContactListById(data.ReceiveCustomerId, "items3").then(
                (success) => {
                  if (success) {
                    var contact = this.contactPersonList.items3.find(
                      (c) => c.value == data.ReceiveContactId
                    );
                    if (contact) {
                      this.seaform.ReceiveContactIdStr = contact.text;
                      this.seaform.ReceiveContactId = contact.value;
                      this.seaform.ReceiveMobile = contact.Mobile;
                    }
                  }
                }
              );
            }
            //通知人
            this.seaform.NotifyObj.value = data.NotifyCustomerId;
            this.seaform.NotifyObj.text = data.NotifyCompanyEn
              ? data.NotifyCompanyEn
              : data.NotifyCompany;
            this.seaform.NotifyAddress = data.NotifyAddress;
            if (data.NotifyCustomerId) {
              this.getCustomerContactListById(data.NotifyCustomerId, "items4").then(
                (success) => {
                  if (success) {
                    var contact = this.contactPersonList.items4.find(
                      (c) => c.value == data.NotifyContactId
                    );
                    if (contact) {
                      this.seaform.NotifyContactIdStr = contact.text;
                      this.seaform.NotifyContactId = contact.value;
                      this.seaform.NotifyMobile = contact.Mobile;
                    }
                  }
                }
              );
            }
            //代理人
            this.seaform.AgentObj.value = data.AgentCustomerId;
            this.seaform.AgentObj.text = data.AgentCompanyEn
              ? data.AgentCompanyEn
              : data.AgentCompany;
            this.seaform.AgentAddress = data.AgentAddress;
            if (data.AgentCustomerId) {
              this.getCustomerContactListById(data.AgentCustomerId, "items5").then(
                (success) => {
                  if (success) {
                    var contact = this.contactPersonList.items5.find(
                      (c) => c.value == data.AgentContactId
                    );
                    if (contact) {
                      this.seaform.AgentContactIdStr = contact.text;
                      this.seaform.AgentContactId = contact.value;
                      this.seaform.AgentMobile = contact.Mobile;
                    }
                  }
                }
              );
            }
            //Port of Discharges
            this.seaform.UnLoad.value = data.UnLoadCountryId;
            var unload = this.countryList.find((c) => c.value == data.UnLoadCityId);
            if (unload) {
              this.seaform.UnLoad.text = unload.text;
              this.seaform.UnLoad.Code = unload.Code;
              this.seaform.UnLoad.CountryId = unload.CountryId;
            }
            //Place of Delivery
            this.seaform.ReceiveCountry.value = data.ReceiveCountryId;
            var receiveCountry = this.countryList.find(
              (c) => c.value == data.ReceiveCityId
            );
            if (receiveCountry) {
              this.seaform.ReceiveCountry.text = receiveCountry.text;
              this.seaform.ReceiveCountry.Code = receiveCountry.Code;
              this.seaform.ReceiveCountry.CountryId = receiveCountry.CountryId;
            }
            resolve(true);
            this.$commonMethod.hideLoading();
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    moreSheetSelect(e) {
      if (this.menuState == 2) {
        if (e.className == "1") {
          this.dialogSeaForm.WB_Number = "";
          this.dialogSeaVisible = true;
        }
      }
      this.moreSheetShow = false;
    },
    handleMoreSheetShow() {
      var actions = [];
      if (this.menuState == 2) {
        actions = [
          {
            name: this.$t.buildWayBillNo.wbNumberData,
            className: "1",
          },
        ];
      }

      this.moreSheetActions = actions;
      this.moreSheetShow = true;
    },
    disableMenuList() {
      for (var menu of this.menuList) {
        if (this.menuState == menu.name) {
          menu.disable = false;
        } else {
          menu.disable = true;
        }
      }
    },
    onSelectOption(e) {
      //空运
      if (this.selectEvent == "showAirDeliveryPerson") {
        this.airform.DeliveryContactIdStr = e.text;
        this.airform.DeliveryContactId = e.value;
        this.airform.DeliveryMobile = e.Mobile;
      }
      if (this.selectEvent == "showAirSendCountry") {
        this.airform.SendCountry = e;
      }
      if (this.selectEvent == "showAirReceivePerson") {
        this.airform.ReceiveContactIdStr = e.text;
        this.airform.ReceiveContactId = e.value;
        this.airform.ReceiveMoblie = e.Mobile;
      }
      if (this.selectEvent == "showAirReceiveCountry") {
        this.airform.ReceiveCountry = e;
      }
      //海运
      if (this.selectEvent == "showSeaDeliveryPerson") {
        this.seaform.ReceiveContactIdStr = e.text;
        this.seaform.ReceiveContactId = e.value;
        this.seaform.ReceiveMobile = e.Mobile;
      }
      if (this.selectEvent == "showSeaNotifyPerson") {
        this.seaform.NotifyContactIdStr = e.text;
        this.seaform.NotifyContactId = e.value;
        this.seaform.NotifyMobile = e.Mobile;
      }
      if (this.selectEvent == "showSeaAgentPerson") {
        this.seaform.AgentContactIdStr = e.text;
        this.seaform.AgentContactId = e.value;
        this.seaform.AgentMobile = e.Mobile;
      }
      if (this.selectEvent == "showSeaUnLoad") {
        this.seaform.UnLoad = e;
      }
      if (this.selectEvent == "showSeaBargeVoyageCountry") {
        this.seaform.BargeVoyageCountry = e;
      }
      if (this.selectEvent == "showSeaSendCountry") {
        this.seaform.SendCountry = e;
      }
      if (this.selectEvent == "showSeaReceiveCountry") {
        this.seaform.ReceiveCountry = e;
      }
      if (this.selectEvent == "showSeaContainer") {
        this.seaform.DetailList[this.detailIndex].ContainerInfoStr = e.text;
        this.seaform.DetailList[this.detailIndex].ContainerInfo = e.value;
        this.seaform.DetailList[this.detailIndex].CTIdStr = "";
        this.seaform.DetailList[this.detailIndex].CTId = "";
        if (this.seaform.PackingType == "1") {
          this.getWayBillCabinetTypeListByClassId(e.value);
          this.getContainerTotal();
          this.getCargoText();
        }
      }
      // 空派/海派/快递
      if (this.selectEvent == "showFormDeliveryCountry") {
        this.form.DeliveryCountry = e;
      }
      if (this.selectEvent == "showFormReceiveCountry") {
        this.form.ReceiveCountry = e;
      }
      this.$forceUpdate();
    },
    onSelectFetch(e) {
      //空运
      if (this.selectEvent == "showAirDeliveryObj") {
        this.airform.DeliveryObj = e;
        this.airform.DeliveryContactIdStr = "";
        this.airform.DeliveryContactId = "";
        this.airform.DeliveryMobile = "";
        this.getCustomerContactListById(e.value, "items1");
      }
      if (this.selectEvent == "showAirDeliveryAddress") {
        this.airform.DeliveryAddress = e.text;
      }
      if (this.selectEvent == "showAirReceiveObj") {
        this.airform.ReceiveObj = e;
        this.airform.ReceiveContactIdStr = "";
        this.airform.ReceiveContactId = "";
        this.airform.ReceiveMoblie = "";
        this.getCustomerContactListById(e.value, "items2");
      }
      if (this.selectEvent == "showAirReceiveAddress") {
        this.airform.ReceiveAddress = e.text;
      }
      //海运
      if (this.selectEvent == "showSeaDeliveryObj") {
        this.seaform.DeliveryObj = e;
      }
      if (this.selectEvent == "showSeaDeliveryAddress") {
        this.seaform.DeliveryAddress = e.text;
      }
      if (this.selectEvent == "showSeaDeliveryObj2") {
        this.seaform.DeliveryObj2 = e;
      }
      if (this.selectEvent == "showSeaReceiveObj") {
        this.seaform.ReceiveObj = e;
        this.seaform.ReceiveContactIdStr = "";
        this.seaform.ReceiveContactId = "";
        this.seaform.ReceiveMobile = "";
        this.getCustomerContactListById(e.value, "items3");
      }
      if (this.selectEvent == "showSeaReceiveAddress") {
        this.seaform.ReceiveAddress = e.text;
      }
      if (this.selectEvent == "showSeaNotifyObj") {
        this.seaform.NotifyObj = e;
        this.seaform.NotifyContactIdStr = "";
        this.seaform.NotifyContactId = "";
        this.seaform.NotifyMobile = "";
        this.getCustomerContactListById(e.value, "items4");
      }
      if (this.selectEvent == "showSeaAgentObj") {
        this.seaform.AgentObj = e;
        this.seaform.AgentContactIdStr = "";
        this.seaform.AgentContactId = "";
        this.seaform.AgentMobile = "";
        this.getCustomerContactListById(e.value, "items5");
      }
      if (this.selectEvent == "showSeaNotifyAddress") {
        this.seaform.NotifyAddress = e.text;
      }
      // 空派/海派/快递
      if (this.selectEvent == "showFormDeliveryObj") {
        this.form.DeliveryObj = e;
      }
      if (this.selectEvent == "showFormReceiveObj") {
        this.form.ReceiveObj = e;
      }
      if (this.selectEvent == "showSeaAgentAddress") {
        this.seaform.AgentAddress = e.text;
      }
      if (this.selectEvent == "showCustomsCode") {
        if (this.menuState == 1) {
          this.airform.DetailList[this.detailIndex].CustomsCode = e.value;
        } else if (this.menuState == 2) {
          this.seaform.DetailList[this.detailIndex].CustomsCode = e.value;
        } else {
          this.form.DetailList[this.detailIndex].CustomsCode = e.value;
        }
      }
      this.$forceUpdate();
    },
    userSelectConfirm(e) {
      if (this.userSelectPickerType == 1) {
        this.userSelect.OperationUserIdStr = e.text;
        this.userSelect.OperationUserId = e.value;
      }
      if (this.userSelectPickerType == 2) {
        this.userSelect.SalesUserIdStr = e.text;
        this.userSelect.SalesUserId = e.value;
      }
      if (this.userSelectPickerType == 3) {
        this.userSelect.CustomerServiceUserIdStr = e.text;
        this.userSelect.CustomerServiceUserId = e.value;
      }
      if (this.userSelectPickerType == 4) {
        this.userSelect.MarketUserIdStr = e.text;
        this.userSelect.MarketUserId = e.value;
      }
      this.showUserSelectPicker = false;
    },
    cabinetPickerShow() {
      this.showCabinetPicker = true;
    },
    cabinetSelectConfirm(e) {
      if (!e) {
        return;
      }
      this.seaform.DetailList[this.detailIndex].CTIdStr = e.text;
      this.seaform.DetailList[this.detailIndex].CTId = e.value;
      this.showCabinetPicker = false;
    },
    pickerShow(pickerName, type) {
      this[pickerName] = true;
      this.userSelectPickerType = type;
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
      for (var form of this.$refs.formRef) {
        form.resetValidation();
      }
      this.initTotalStatistics();
    },
    onShowEmit(emit, index) {
      if (emit == "showAirDeliveryPerson" && this.contactPersonList.items1.length == 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.buildWayBillNo.contactError,
          type: "error",
        });
        return;
      }
      if (emit == "showAirReceivePerson" && this.contactPersonList.items2.length == 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.buildWayBillNo.contactError,
          type: "error",
        });
        return;
      }
      if (emit == "showSeaDeliveryPerson" && this.contactPersonList.items3.length == 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.buildWayBillNo.contactError,
          type: "error",
        });
        return;
      }
      if (emit == "showSeaNotifyPerson" && this.contactPersonList.items4.length == 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.buildWayBillNo.contactError,
          type: "error",
        });
        return;
      }
      if (emit == "showSeaAgentPerson" && this.contactPersonList.items5.length == 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.buildWayBillNo.contactError,
          type: "error",
        });
        return;
      }
      if (emit == "showSeaContainer") {
        if (this.seaform.PackingType == "1") {
          this.containerInfoSelectList = [
            { text: "20'", value: "1" },
            { text: "40'", value: "2" },
            { text: "40HQ", value: "3" },
            { text: "OTHERS", value: "4" },
          ];
        } else {
          this.containerInfoSelectList = [{ text: "LCL", value: "5" }];
        }
        this.detailIndex = index;
      }
      if (emit == "showCustomsCode") {
        this.detailIndex = index;
      }
      this.selectEvent = emit;
      setTimeout(() => {
        this.$bus.$emit(emit, true);
      });
    },
    showDialogTimeDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showDialogTimePicker = true;
    },
    showTimeDate(param) {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.dateTimeParam = param;
      this.showTimePicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date) {
      var formatDate = (val) => {
        var value = new Date(val);
        var time = value.toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (this.menuState == 1) {
        this.airform[this.dateTimeParam] = formatDate(date);
      }
      if (this.menuState == 2) {
        this.seaform[this.dateTimeParam] = formatDate(date);
      }
      this.showTimePicker = false;
    },
    dateChange2(date) {
      var formatDate = (val) => {
        var value = new Date(val);
        var time = value.toLocaleDateString();
        var hour = value.getHours() < 10 ? "0" + value.getHours() : value.getHours();
        var minute =
          value.getMinutes() < 10 ? "0" + value.getMinutes() : value.getMinutes();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date + " " + hour + ":" + minute;
      };
      this.dialogBillingForm.Naqel_ShippingDateTime = formatDate(date);
      this.showDialogTimePicker = false;
    },
    handleAirAdd() {
      this.airform.DetailList.push({
        GoodsDescribe: "",
        CustomsCode: "",
        COD: "",
        Weight: "",
        BoxNumber: "",
        Volume: "",
        ItemPrice: "",
        Currency: "",
        NumberUnit: "",
      });
      this.getAllStatistics();
    },
    handleAirDel() {
      if (this.airform.DetailList.length > 0) {
        this.airform.DetailList.pop();
      }
      this.getAllStatistics();
    },
    handleAirDelByIndex(index) {
      if (this.airform.DetailList.length > 0) {
        this.airform.DetailList.splice(index, 1);
      }
      this.getAllStatistics();
    },
    handleSeaAdd() {
      this.seaform.DetailList.push({
        GoodsDescribe: "",
        CustomsCode: "",
        ContainerInfoStr: "",
        ContainerInfo: "",
        CTIdStr: "",
        CTId: "",
        ContainerNo: "",
        Weight: "",
        BoxNumber: "",
        Volume: "",
        SealNo: "",
        Unit: "",
        Options: [],
      });
      this.getAllStatistics();
    },
    handleSeaDel() {
      if (this.seaform.DetailList.length > 0) {
        this.seaform.DetailList.pop();
      }
      this.getAllStatistics();
    },
    handleSeaDelByIndex(index) {
      if (this.form.DetailList.length > 0) {
        this.form.DetailList.splice(index, 1);
      }
      this.getAllStatistics();
    },
    handleFormAdd() {
      this.form.DetailList.push({
        GoodsDescribe: "",
        CustomsCode: "",
        COD: "",
        Weight: "",
        BoxNumber: "",
        Volume: "",
        ItemPrice: "",
        Currency: "",
        NumberUnit: "",
        CargoQuantity: "",
      });
      this.getAllStatistics();
    },
    handleFormDel() {
      if (this.form.DetailList.length > 0) {
        this.form.DetailList.pop();
      }
      this.getAllStatistics();
    },
    handleFormDelByIndex(index) {
      if (this.form.DetailList.length > 0) {
        this.form.DetailList.splice(index, 1);
      }
      this.getAllStatistics();
    },
    packingTypeChange() {
      this.seaform.DetailList = [
        {
          ContainerInfoStr: "",
          ContainerInfo: "",
          CTIdStr: "",
          CTId: "",
          ContainerNo: "",
          Weight: "",
          BoxNumber: "",
          Volume: "",
          SealNo: "",
          Unit: "",
          Options: [],
        },
      ];
    },
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([
          this.getCountryList(false),
          this.getCurrencyList(),
          this.getUserListByCondition(),
        ])
          .then((success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          })
          .catch(() => {
            this.$commonMethod.hideLoading();
          });
      });
    },
    getCountryList(showLoading) {
      return new Promise((resolve) => {
        if (showLoading) {
          this.$commonMethod.showLoading();
        }
        this.$api.logisticsManagement
          .getCountryList({
            type: this.menuState == 2 || this.menuState == 4 ? 2 : 1,
          })
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text:
                  item.CountryName +
                  "-" +
                  item.CountryName_en +
                  " , " +
                  item.City_cn +
                  "-" +
                  item.City_en +
                  " , " +
                  item.Code,
                value: item.Id,
                CountryId: item.CountryId,
                Code: item.Code,
              };
              result.push(data);
            });
            this.countryList = result;
            if (showLoading) {
              this.$commonMethod.hideLoading();
            }
            resolve(true);
          })
          .catch((error) => {
            if (showLoading) {
              this.$commonMethod.hideLoading();
            }
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getSystemAvailableCurrencyList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CurrencySn,
                value: item.SCId,
              };
              result.push(data);
            });
            this.currencyList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getUserListByCondition() {
      return new Promise((resolve) => {
        this.$api.systemManagement
          .getUserListByCondition({
            CompanyId: this.CompanyId,
            IsUse: 1,
          })
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.UserName,
                value: parseInt(item.UserId),
                disabled: false,
              };
              result.push(data);
            });
            this.userList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCustomerContactListById(id, itemName) {
      return new Promise((resolve) => {
        var param = {
          CustomerId: id,
        };
        this.$api.customerManagement
          .getCustomerContactListById(param)
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.ContactPerson,
                value: item.ContactId,
                Mobile: item.Mobile,
              };
              result.push(data);
            });
            this.contactPersonList[itemName] = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getWayBillCabinetTypeListByClassId(id) {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        var param = {
          ClassId: id,
        };
        this.$api.logisticsManagement
          .getWayBillCabinetTypeListByClassId(param)
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              if (item.ClassId == id) {
                let data = {
                  text: item.ClassName,
                  value: item.CTId,
                  ClassId: item.ClassId,
                };
                result.push(data);
              }
            });
            this.seaform.DetailList[this.detailIndex].Options = result;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getAllStatistics() {
      this.getAllWeight();
      this.getAllBoxNumber();
      this.getAllVolume();
      this.getTotalCargoQuantity();
      this.getContainerTotal();
    },
    initTotalStatistics() {
      this.airform.AllWeight = 0;
      this.airform.AllBoxNumber = 0;
      this.airform.AllVolume = 0;
      this.airform.DetailList = [
        {
          GoodsDescribe: "",
          CustomsCode: "",
          COD: "",
          Weight: "",
          BoxNumber: "",
          Volume: "",
          ItemPrice: "",
          Currency: "",
          NumberUnit: "",
        },
      ];
      this.seaform.AllWeight = 0;
      this.seaform.AllBoxNumber = 0;
      this.seaform.AllVolume = 0;
      this.seaform.DetailList = [
        {
          ContainerInfoStr: "",
          ContainerInfo: "",
          CTIdStr: "",
          CTId: "",
          ContainerNo: "",
          Weight: "",
          BoxNumber: "",
          Volume: "",
          SealNo: "",
          Unit: "",
          Options: [],
        },
      ];
      this.form.AllWeight = 0;
      this.form.AllBoxNumber = 0;
      this.form.AllVolume = 0;
      this.form.TotalCargoQuantity = 0;
      this.form.DetailList = [
        {
          GoodsDescribe: "",
          CustomsCode: "",
          COD: "",
          Weight: "",
          BoxNumber: "",
          Volume: "",
          ItemPrice: "",
          Currency: "",
          NumberUnit: "",
          CargoQuantity: "",
        },
      ];
    },
    getAllWeight() {
      let num = 0;
      switch (this.menuState) {
        case 1:
          this.airform.DetailList.forEach((item) => (num = Number(item["Weight"]) + num));
          break;
        case 2:
          this.seaform.DetailList.forEach((item) => (num = Number(item["Weight"]) + num));
          break;
        case 3:
          this.form.DetailList.forEach((item) => (num = Number(item["Weight"]) + num));
          break;
        case 4:
          this.form.DetailList.forEach((item) => (num = Number(item["Weight"]) + num));
          break;
        case 5:
          this.form.DetailList.forEach((item) => (num = Number(item["Weight"]) + num));
          break;
      }
      this.seaform["AllWeight"] = num.toFixed(3);
      this.airform["AllWeight"] = num.toFixed(3);
      this.form["AllWeight"] = num.toFixed(3);
    },
    getAllBoxNumber() {
      let num = 0;
      switch (this.menuState) {
        case 1:
          this.airform.DetailList.forEach(
            (item) => (num = Number(item["BoxNumber"]) + num)
          );
          break;
        case 2:
          this.seaform.DetailList.forEach(
            (item) => (num = Number(item["BoxNumber"]) + num)
          );
          break;
        case 3:
          this.form.DetailList.forEach((item) => (num = Number(item["BoxNumber"]) + num));
          break;
        case 4:
          this.form.DetailList.forEach((item) => (num = Number(item["BoxNumber"]) + num));
          break;
        case 5:
          this.form.DetailList.forEach((item) => (num = Number(item["BoxNumber"]) + num));
          break;
      }
      this.seaform["AllBoxNumber"] = num;
      this.airform["AllBoxNumber"] = num;
      this.form["AllBoxNumber"] = num;
    },
    getAllVolume() {
      let num = 0;
      switch (this.menuState) {
        case 1:
          this.airform.DetailList.forEach((item) => (num = Number(item["Volume"]) + num));
          break;
        case 2:
          this.seaform.DetailList.forEach((item) => (num = Number(item["Volume"]) + num));
          break;
        case 3:
          this.form.DetailList.forEach((item) => (num = Number(item["Volume"]) + num));
          break;
        case 4:
          this.form.DetailList.forEach((item) => (num = Number(item["Volume"]) + num));
          break;
        case 5:
          this.form.DetailList.forEach((item) => (num = Number(item["Volume"]) + num));
          break;
      }
      this.seaform["AllVolume"] = num.toFixed(3);
      this.airform["AllVolume"] = num.toFixed(3);
      this.form["AllVolume"] = num.toFixed(3);
    },
    getTotalCargoQuantity() {
      let num = 0;
      switch (this.menuState) {
        case 3:
          this.form.DetailList.forEach(
            (item) => (num = Number(item["CargoQuantity"]) + num)
          );
          break;
        case 4:
          this.form.DetailList.forEach(
            (item) => (num = Number(item["CargoQuantity"]) + num)
          );
          break;
        case 5:
          this.form.DetailList.forEach(
            (item) => (num = Number(item["CargoQuantity"]) + num)
          );
          break;
      }
      this.form["TotalCargoQuantity"] = num;
    },
    getContainerTotal() {
      var count1 = 0;
      var count2 = 0;
      var count3 = 0;
      var count4 = 0;
      this.seaform.DetailList.forEach((item) => {
        if (item["ContainerInfo"] === "1") {
          count1 = count1 + 1;
        }
        if (item["ContainerInfo"] === "2") {
          count2 = count2 + 1;
        }
        if (item["ContainerInfo"] === "3") {
          count3 = count3 + 1;
        }
        if (item["ContainerInfo"] === "4") {
          count4 = count4 + 1;
        }
      });
      this.seaform.TotalContainers_X20 = count1;
      this.seaform.TotalContainers_X40 = count2;
      this.seaform.TotalContainers_X40HQ = count3;
      this.seaform.TotalContainers_XOthers = count4;
    },
    handleSubmit() {
      if (this.COIds && this.COIds.length > 0) {
        this.dialogBillingShow();
      } else {
        this.onSubmit();
      }
    },
    onSubmit() {
      var param = {};
      var request = null;
      if (this.menuState == 1) {
        if (!this.airform.DepartureDate) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: "Flight/Date " + this.$t.meta.require,
            type: "error",
          });
          return;
        }
        param = { ...this.airform, ...this.userSelect };
        param.DeliveryCustomerId = this.airform.DeliveryObj.value;
        param.DeliveryCountryId = this.airform.SendCountry.CountryId;
        param.DeliveryCityId = this.airform.SendCountry.value;
        param.DeliveryCityCode = this.airform.SendCountry.Code;
        param.ReceiveCustomerId = this.airform.ReceiveObj.value;
        param.ReceiveCountryId = this.airform.ReceiveCountry.CountryId;
        param.ReceiveCityId = this.airform.ReceiveCountry.value;
        param.ReceiveCityCode = this.airform.ReceiveCountry.Code;
        request = this.$api.logisticsManagement.addAirWayBill(param);
      } else if (this.menuState == 2) {
        if (!this.seaform.SailingDate) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: "Ship on board date " + this.$t.meta.require,
          });
          return;
        }
        param = { ...this.seaform, ...this.userSelect };
        param.DeliveryCustomerId = this.seaform.DeliveryObj.value;
        param.DeliveryCountryId = this.seaform.SendCountry.CountryId;
        param.DeliveryCityId = this.seaform.SendCountry.value;
        param.DeliveryCityCode = this.seaform.SendCountry.Code;
        param.ReceiveCustomerId = this.seaform.ReceiveObj.value;
        param.ReceiveCountryId = this.seaform.ReceiveCountry.CountryId;
        param.ReceiveCityId = this.seaform.ReceiveCountry.value;
        param.ReceiveCityCode = this.seaform.ReceiveCountry.Code;
        param.UnLoadCountryId = this.seaform.UnLoad.CountryId;
        param.UnLoadCityId = this.seaform.UnLoad.value;
        param.BargeVoyageCountryId = this.seaform.BargeVoyageCountry.CountryId;
        param.BargeVoyageCityId = this.seaform.BargeVoyageCountry.value;
        param.IsCO = this.seaform.IsCO ? 1 : 0;
        param.SecondDeliveryCustomerId = this.seaform.IsCO
          ? this.seaform.DeliveryObj2.value
          : "";
        param.IsSelectAnotherOne = this.seaform.IsSelectAnotherOne ? 1 : 0;
        param.NotifyCustomerId = this.seaform.IsSelectAnotherOne
          ? this.seaform.NotifyObj.value
          : "";
        param.AgentCustomerId = this.seaform.AgentObj.value;
        request = this.$api.logisticsManagement.addWayBillShippingByNew(param);
      } else {
        param = { ...this.form, ...this.userSelect };
        param.WB_Type = this.menuState;
        param.DeliveryCustomerId = this.form.DeliveryObj.value;
        param.DeliveryCountryId = this.form.DeliveryCountry.CountryId;
        param.DeliveryCityId = this.form.DeliveryCountry.value;
        param.DeliveryCityCode = this.form.DeliveryCountry.Code;
        param.ReceiveCustomerId = this.form.ReceiveObj.value;
        param.ReceiveCountryId = this.form.ReceiveCountry.CountryId;
        param.ReceiveCityId = this.form.ReceiveCountry.value;
        param.ReceiveCityCode = this.form.ReceiveCountry.Code;
        request = this.$api.logisticsManagement.addWayBill(param);
      }
      if (this.COIds && this.COIds.length > 0) {
        param.COIdList = this.COIds;
        param.FPId = this.dialogBillingForm.FPId;
        param.FPDId = this.dialogBillingForm.FPDId;
        param.Length = this.dialogBillingForm.Length;
        param.Width = this.dialogBillingForm.Width;
        param.Height = this.dialogBillingForm.Height;
        param.WeightKG = this.dialogBillingForm.WeightKG;
        if (this.form.LogisticsChannel) {
          param.declaredValue = this.dialogBillingForm.declaredValue;
          param.declaredValueCurrency = this.dialogBillingForm.declaredValueCurrency;
          param.Naqel_ShippingDateTime = this.dialogBillingForm.Naqel_ShippingDateTime;
          param.Naqel_DescriptionOfGoods = this.dialogBillingForm.Naqel_DescriptionOfGoods;
          param.Naqel_NumberOfPieces = this.dialogBillingForm.Naqel_NumberOfPieces;
          param.iMile_PackageTotalVolume = this.dialogBillingForm.iMile_PackageTotalVolume;
          param.iMile_PackageGrossWeight = this.dialogBillingForm.iMile_PackageGrossWeight;
          param.iMile_PackageTotalCount = this.dialogBillingForm.iMile_PackageTotalCount;
          param.iMile_PackageGoodsType = this.dialogBillingForm.iMile_PackageGoodsType;
          param.DeliveryZipCode = this.dialogBillingForm.deliveryZipCode;
        }
      }
      if (this.SOPId) {
        param.SOPId = this.SOPId;
      }
      param.WB_Type = this.menuState;
      param.CompanyId = this.CompanyId;
      param.UserId = this.UserId;
      this.$commonMethod.showLoading();
      request
        .then(() => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.operateSuccess,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onFailed(errorInfo) {
      if (errorInfo && errorInfo.errors.length > 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: errorInfo.errors[0].name + " " + errorInfo.errors[0].message,
        });
      }
    },
    getRemarkText(index) {
      var goodsDescribe = this.seaform.DetailList[index].GoodsDescribe;
      var customsCode = this.seaform.DetailList[index].CustomsCode;
      if (goodsDescribe && customsCode) {
        this.seaform.Remark =
          this.seaform.Remark + goodsDescribe + " " + customsCode + "\n";
      }
    },
    getCargoText() {
      var count1 = 0;
      var count2 = 0;
      var count3 = 0;
      var count4 = 0;
      this.seaform.DetailList.forEach((item) => {
        if (item["ContainerInfo"]) {
          if (item["ContainerInfo"] === "1") {
            count1 = count1 + 1;
          }
          if (item["ContainerInfo"] === "2") {
            count2 = count2 + 1;
          }
          if (item["ContainerInfo"] === "3") {
            count3 = count3 + 1;
          }
          if (item["ContainerInfo"] === "4") {
            count4 = count4 + 1;
          }
        }
      });
      var container =
        (count1 ? count1 + "X20'" + (count2 || count3 || count4 ? "+" : "") : "") +
        (count2 ? count2 + "X40'" + (count3 || count4 ? "+" : "") : "") +
        (count3 ? count3 + "X40HQ" + (count4 ? "+" : "") : "") +
        (count4 ? count4 + "XOthers" : "");
      this.seaform.Cargo =
        "SAY " +
        this.numberToWords(count1 + count2 + count3 + count4) +
        " (" +
        container +
        ") " +
        "CONTAINER(S) ONLY";
    },
    numberToWords(num) {
      const belowTwenty = [
        "zero",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "ten",
        "eleven",
        "twelve",
        "thirteen",
        "fourteen",
        "fifteen",
        "sixteen",
        "seventeen",
        "eighteen",
        "nineteen",
      ];
      const tens = [
        "",
        "",
        "twenty",
        "thirty",
        "forty",
        "fifty",
        "sixty",
        "seventy",
        "eighty",
        "ninety",
      ];

      if (num === 0) return "zero";

      let result = "";
      let numStr = num.toString();

      if (numStr.length > 3) {
        const billions = Math.floor(num / 1000000000);
        result += numberToWords(billions) + " billion ";
        num %= 1000000000;
      }

      if (numStr.length > 6) {
        const millions = Math.floor(num / 1000000);
        result += numberToWords(millions) + " million ";
        num %= 1000000;
      }

      if (numStr.length > 3) {
        const thousands = Math.floor(num / 1000);
        result += numberToWords(thousands) + " thousand ";
        num %= 1000;
      }

      if (num > 0) {
        if (num < 20) {
          result += belowTwenty[num];
        } else {
          const hundred = Math.floor(num / 100);
          result += numberToWords(hundred) + " hundred ";
          const remainder = num % 100;
          if (remainder > 0) {
            if (remainder < 20) {
              result += belowTwenty[remainder];
            } else {
              const ten = Math.floor(remainder / 10);
              result += tens[ten] + " " + belowTwenty[remainder % 10];
            }
          }
        }
      }
      return result.trim();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.buildWayBillNo {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
    .van-button {
      padding: 6px 8px;
      height: auto;
      ::v-deep .van-button__text {
        font-size: 12px !important;
      }
    }
  }
  .van-cell::after {
    border: none !important;
  }
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-radio__label--disabled.van-radio__label {
    color: #646566 !important;
    -webkit-text-fill-color: #646566 !important;
  }
  ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-checkbox__label--disabled.van-checkbox__label {
    color: #646566 !important;
    -webkit-text-fill-color: #646566 !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #646566 !important;
      -webkit-text-fill-color: #646566 !important;
    }
  }
  .custom-field {
    font-size: 14px;
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .custom-field-label {
      width: 120px;
      display: inline-block;
      margin-right: 12px;
      font-size: 14px;
      color: #646566;
      vertical-align: middle;
    }
    .custom-field-value {
      width: 50%;
      display: inline-block;
      font-size: 14px;
      color: #323233;
      vertical-align: middle;
      .custom-field-number {
        width: 50%;
        display: inline-block;
      }
    }
  }
  .buildWayBillNo-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .buildWayBillNo-checkbox {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .checkbox-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-checkbox {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .custom-date {
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .date-btn1 {
      width: 120px;
      display: inline-block;
      margin-right: 12px;
      font-size: 14px;
      color: #646566;
      vertical-align: middle;
      .date-require {
        color: red;
        position: absolute;
        left: 8px;
      }
    }
    .date-btn2 {
      width: 50%;
      display: inline-block;
      font-size: 14px;
      vertical-align: middle;
      .value {
        color: #323233;
      }
      .placeholder {
        color: #c3c3c3;
      }
    }
  }
  .custom-date2 {
    background: #ffffff;
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .date-btn1 {
      width: 100px;
      display: inline-block;
      margin-right: 12px;
      font-size: 14px;
      color: #646566;
      vertical-align: middle;
      .date-require {
        color: red;
        position: absolute;
        left: 8px;
      }
    }
    .date-btn2 {
      width: 50%;
      display: inline-block;
      font-size: 14px;
      vertical-align: middle;
      .value {
        color: #323233;
      }
      .placeholder {
        color: #c3c3c3;
      }
    }
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #2c88c1;
        width: 70%;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 30%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
        ::v-deep .van-button__text {
          font-size: 14px !important;
        }
      }
    }
  }
  .buildWayBillNo-alert {
    overflow: scroll;
    margin-top: 30px;
    margin-bottom: 30px;
    border-top: 1px solid #ebedf0;
    position: relative;
    .multi-table {
      .multi-table-header {
        padding: 10px 15px;
        .multi-table-title {
          font-size: 14px;
          color: #999;
          display: inline-block;
          vertical-align: middle;
        }
        .multi-table-btn {
          font-size: 20px;
          color: #000;
          width: 100%;
          display: inline-block;
          text-align: right;
          vertical-align: middle;
        }
      }
    }
  }
  .billing-alert {
    overflow: scroll;
    height: 100vw;
    margin-top: 20px;
    margin-bottom: 20px;
    border-top: 1px solid #ebedf0;
    .dialog-container {
      .dialog-table {
        font-size: 12px;
        color: #333;
        border-bottom: 1px solid #ebedf0;
        .dialog-item {
          margin-bottom: 10px;
        }
        .dialog-item:last-child {
          margin-bottom: 0px !important;
        }
      }
      .dialog-table-footer {
        text-align: center;
        margin-top: 20px;
        margin-bottom: 20px;
        .primary-btn {
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .submit-button {
      width: 70%;
      border: none;
      border-radius: 0px;
      display: inline-block;
    }
    .more-button {
      background: #5029c3;
      color: #fff;
      border: none;
      border-radius: 0px;
      display: inline-block;
      width: 30%;
    }
  }
  .dialog-item-row {
    margin-bottom: 10px;
    .van-col {
      text-align: left;
      font-size: 12px;
    }
  }
}
</style>
